import {Link} from "react-router-dom";

export default function SidebarMenu( { singleOption, isActive } ) {
    const { key, label, leftIcon, children, hasPermission } = singleOption;

    if(!children && (hasPermission || hasPermission == undefined)) {
        return (
            <li className={ `nav-item pillvery-sidebar-item ${isActive ? "active" : null}` }>
                <Link className="nav-link" to={ "/dashboard/"+ key }>
                    <i className={ leftIcon }></i>
                    <span className="menu-title"> { label } </span>
                </Link>
            </li>
        )
    }

    return null;
    // return (
    //     <li className="nav-item">
    //         <a className="nav-link" href={"#"+key} data-toggle="collapse" aria-expanded="false" aria-controls = { key }>
    //             <i className={ leftIcon }></i>
    //             <span className="menu-title">{ label }</span>
    //             <i className="menu-arrow"></i>
    //         </a>
    //         <SidebarSingleMenuChildren
    //             children    = { children }
    //             key         = { key }
    //             sharedKey   = { key }
    //         />
    //     </li>
    // )
}

function SidebarSingleMenuChildren({children, sharedKey}) {

    return (
        <div className="collapse" id={ sharedKey }>
            <ul className="nav flex-column sub-menu">
                {
                    children.map(item => (
                        <li className="nav-item">
                            <Link className="nav-link" to={ "/dashboard/"+item.key }>
                                { item.label }
                            </Link>
                        </li>
                    ))
                }

            </ul>
        </div>
    );
}